import React from 'react';
import {
  SinglePageHeader,
  FooterWithoutAuth,
  BlogCard,
  Layout,
} from 'components';
import './packages-and-payment-page.less';

import './blog.less';
import marketingImg from 'assests/images/blog-toplu-mms.jpg';
import blogBannerAccessory1 from 'assests/images/pap-accessory-1.png';
import blogBannerAccessory2 from 'assests/images/features-accessory-3.png';
import { LANDING_MENU } from 'constants/page.const';
import { MetaTags } from 'react-meta-tags';

const BayramPage = () => {
  return (
    <Layout
      hamburgerMenuWithButton={true}
      hamburgerMenuData={LANDING_MENU}
      hamburgerMenuClass="single-page-v1"
      withoutHeaderDropdown={true}
      withoutCreditInfo={true}
      menuSinglePageV2={true}
      customMenuRender={() => <SinglePageHeader />}
    >
      <MetaTags>
        <title>
          Bayram Mesajları 2023 : Kurban ve Ramazan Bayramı Mesajları
        </title>
        <meta
          name="description"
          content="Kurban Bayramı ve Ramazan Bayramı mesajlarını inceleyebilirsiniz. Kısa, en güzel ve değişik bayram mesajlarını kullanarak sevdiklerinize toplu sms atın."
        />
        <link
          rel="canonical"
          href="https://mesajussu.turkcell.com.tr/bayram-mesajlari"
        />
      </MetaTags>
      <div className="blog-page blog-page--marketing">
        <div className="blog-banner">
          <div className="container">
            <div>
              <h1 className="section__title--big">
                Bayram Mesajları 2023: En Güzel ve Kısa Bayram Mesajları
              </h1>
              <p className="info-text--big">
                En güzel ve değişik bayram mesajlarıyla iyi dileklerinizi
                sevdiklerinizle paylaşın.
              </p>
            </div>
            <figure>
              <img src={marketingImg} alt="Bayram Mesajları 2023: En Güzel ve Kısa Bayram Mesajları" />
            </figure>
          </div>
          <img
            id="blog-banner-accessory-1"
            src={blogBannerAccessory1}
            alt="Bayram Mesajları 2023: En Güzel ve Kısa Bayram Mesajları 2"
          />
          <img
            id="blog-banner-accessory-2"
            src={blogBannerAccessory2}
            alt="Bayram Mesajları 2023: En Güzel ve Kısa Bayram Mesajları 3"
          />
        </div>
        <div className="blogs-wrapper">
          <div className="container">
            <ul>
              <li>
                <p>
                  Bayramlarda sevdiklerimizin yanında olamasak da{' '}
                  <strong>bayram mesajlarıyla</strong>&nbsp;onların manevi
                  olarak yanında olduğumuzu belirtmek &ouml;nemlidir.
                  K&uuml;slerin barıştığı, mutluluk ve iyi dileklerin
                  paylaşıldığı bayramda, bayram mesajı atarak sevdiklerinizin
                  yanında olduğunuzu hatırlatabilirsiniz.
                </p>
                <p>
                  Bayramı en i&ccedil;ten dileklerinizle kutlamanıza yardımcı
                  olmak i&ccedil;in, bu yıl ailenize, arkadaşlarınıza ve
                  sevdiklerinize g&ouml;nderebileceğiniz{' '}
                  <strong>Kurban Bayramı</strong>&nbsp;ve{' '}
                  <strong>Ramazan Bayramı mesajlarını</strong>&nbsp;hazırladık.
                  Bayram mesajları 2023<strong>&nbsp;</strong>trendlerininin de
                  yer aldığı bu bayramı mesajları rehberinde;{' '}
                  <strong>en g&uuml;zel ve değişik bayram mesajlarını </strong>
                  bulabilirsiniz. Kısa bayram mesajları, ayrıntılı uzun bayram
                  mesajlarının da yanı sıra şirketlerin{' '}
                  <a
                    href="https://mesajussu.turkcell.com.tr/toplu-sms"
                    target="_blank"
                  >
                    <strong>
                      <u>toplu SMS</u>
                    </strong>
                  </a>
                  &nbsp;uygulamalarında atabileceği kurumsal Kurban Bayramı ve
                  Ramazan Bayramı mesajlarını da yine aşağıdaki rehberde
                  bulabilirsiniz.
                </p>
                <h2>
                  <strong>Bayram Mesajlarının &Ouml;nemi </strong>
                </h2>
                <p>
                  Ramazan Bayramı ve Kurban Bayramı M&uuml;sl&uuml;manların en
                  &ouml;nemli iki bayramıdır ve insanlar bu g&uuml;nleri
                  b&uuml;y&uuml;k bir coşkuyla kutlarlar. Bayram namazının
                  gruplar halinde kılınması, tatlıların yenmesi ve bayram
                  tebriklerinin paylaşılması bu mutlu g&uuml;n&uuml;n olmazsa
                  olmazlarıdır. Bayramda sevdiklerinize &lsquo;Bayramınız
                  M&uuml;barek Olsun&rsquo; diyerek bu neşeyi
                  b&uuml;y&uuml;tebilirsiniz. Bu atabileceğiniz en minimum
                  mesajdır, ancak sevdiklerinize daha sıcak bir şekilde dilek
                  dilemek istiyorsanız,{' '}
                  <strong>
                    Kurban Bayramı mesajları ve Ramazan Bayramı mesajları
                  </strong>
                  &nbsp;dileklerinden oluşan derlememize g&ouml;z atabilirsiniz.
                  En g&uuml;zel bayram mesajları,{' '}
                  <strong>değişik bayram mesajları</strong>&nbsp;ve kurumsal
                  bayram mesajlarının da yer aldığı bu tatlı s&ouml;zleri
                  paylaşmak kesinlikle bayram sevincini kat kat artıracaktır.
                </p>
                <h2>
                  <strong>Kurban Bayramı Mesajları</strong>
                </h2>
                <p>
                  Kurban Bayramı&rsquo;nda sevdiklerinize
                  g&ouml;nderebileceğiniz en g&uuml;zel bayram mesajlarını
                  aşağıda paylaştık.
                </p>
                <ul>
                  <li>Kurban Bayramınız Kutlu Olsun!</li>
                </ul>
                <ul>
                  <li>Sizin ve ailenizin Kurban Bayramı M&uuml;barek olsun.</li>
                </ul>
                <ul>
                  <li>
                    Kurban Bayramınız M&uuml;barek olsun! T&uuml;m sevgi ve
                    mutluluk sizinle olsun.
                  </li>
                </ul>
                <ul>
                  <li>Size ve ailenize sağlıklı bir bayram dileriz.</li>
                </ul>
                <ul>
                  <li>
                    Kurban Bayramınız M&uuml;barek olsun! Sağlıklı ve huzurlu
                    bir bayram ge&ccedil;irmeniz dileğiyle.
                  </li>
                </ul>
                <ul>
                  <li>
                    Sizin ve ailenizin Kurban Bayramını kutlarım. Mutlu ve
                    g&uuml;zel bir Kurban Bayramı dileriz.
                  </li>
                </ul>
                <p>
                  <strong>&nbsp;</strong>
                </p>
                <h2>
                  <strong>Ramazan Bayramı Mesajları </strong>
                </h2>
                <p>
                  Bayram mesajları yazması en zor mesajlardan olarak
                  g&ouml;r&uuml;lse de, bu &ouml;nerilerimizle sevdiklerinizi
                  mutlu edebilirsiniz. İşte sevdiklerinize
                  g&ouml;nderebileceğiniz bayram tebrikleri:
                </p>
                <ul>
                  <li>
                    İl&acirc;hi saadet evlerimizi ve kalplerimizi doldursun.
                    Hepinizin Ramazan Bayramı m&uuml;barek olsun!
                  </li>
                </ul>
                <ul>
                  <li>Ramazan Bayramınız Kutlu Olsun!</li>
                </ul>
                <ul>
                  <li>
                    Sizin ve ailenizin Ramazan Bayramı M&uuml;barek olsun.
                  </li>
                </ul>
                <ul>
                  <li>
                    Ramazan Bayramınız M&uuml;barek olsun! T&uuml;m sevgi ve
                    mutluluk sizinle olsun.
                  </li>
                </ul>
                <ul>
                  <li>Size ve ailenize &ccedil;ok mutlu bir bayram dileriz.</li>
                </ul>
                <ul>
                  <li>Bayramınız M&uuml;barek olsun!</li>
                </ul>
                <ul>
                  <li>
                    Sizin ve ailenizin Ramazan Bayramını kutlarım. Huzurlu ve
                    mutlu bir Ramazan Bayramınız olsun!
                  </li>
                </ul>
                <p>
                  <strong>&nbsp;</strong>
                </p>
                <h2>
                  <strong>En G&uuml;zel Bayram Mesajları </strong>
                </h2>
                <p>
                  <strong>Bayram mesajları 2023</strong>&nbsp;yılında da
                  sevdiklerinizin yanında olduğunuzu hissettirmek i&ccedil;in
                  harika bir yoldur. Kurban Bayramı ve Ramazan Bayramı olmak
                  &uuml;zere her iki bayramda da kullanabileceğiniz bayram
                  mesajları hazırladık.{' '}
                  <strong>En g&uuml;zel bayram mesajlarını </strong>aşağıda
                  inceleyebilirsiniz<strong>:</strong>{' '}
                </p>
                <ul>
                  <li>
                    Sizin ve ailenizin en i&ccedil;ten dileklerimle Kurban
                    Bayramını kutlarım. Bayramınız M&uuml;barek Olsun!
                  </li>
                  <li>
                    Kurban Bayramı'nda Allah size ve ailenize sağlık, zenginlik
                    ve mutluluk versin. Bayramınız M&uuml;barek Olsun!
                  </li>
                  <li>
                    Kurban Bayramı'nın bu hayırlı g&uuml;n&uuml;nde, size umut
                    ve mutluluk diliyorum. Sizin ve ailenizin Kurban Bayramınız
                    M&uuml;barek olsun!
                  </li>
                  <li>Sizin ve ailenizin Kurban Bayramını Kutlarım!</li>
                  <li>
                    Size ve ailenize sağlıklı bir &ouml;m&uuml;r ve &ccedil;ok
                    mutlu bir Kurban Bayramı diliyoruz!
                  </li>
                  <li>
                    Bu Ramazan Bayramı'nda, t&uuml;m hayallerinizin bir an
                    &ouml;nce ger&ccedil;ekleşmesini dilerim. Bayramınız
                    M&uuml;barek Olsun!
                  </li>
                  <li>
                    Bu bayram size huzur, refah ve ger&ccedil;ek mutluluk
                    versin. Bayramınız M&uuml;barek Olsun!
                  </li>
                  <li>
                    Bu Ramazan Bayramı'nın size ve sevdiklerinize barış, uyum,
                    mutluluk, sağlık, başarı ve refah diliyorum. Sizin ve evdeki
                    herkesin bayramı m&uuml;barek olsun.
                  </li>
                  <li>
                    Bu yıl hayatınınız şeker kadar tatlı olsun. Ramazan
                    Bayramınız M&uuml;barek Olsun!
                  </li>
                  <li>
                    Şu an yanınızda olamayabilirim ama bu hayırlı g&uuml;nde en
                    sıcak dileklerim sizinle. Ramazan Bayramınız m&uuml;barek
                    olsun.
                  </li>
                  <li>
                    Bu Ramazan Bayramı size ve ailenize bolca neşe ve sağlık
                    getirsin. Bayramınız M&uuml;barek olsun!
                  </li>
                  <li>
                    Bug&uuml;n t&uuml;m dileklerimiz ger&ccedil;ekleşsin. Allah
                    sağlık, sıhhat ve afiyet versin. Sizin ve ailenizin Ramazan
                    Bayramınız m&uuml;barek olsun
                  </li>
                  <li>Ramazan Bayramınız Kutlu Olsun!</li>
                  <li>
                    Herkese huzur ve mutluluk dolu bir bayram dileriz. Sizin ve
                    ailenizin Bayramını kutlarız!
                  </li>
                  <li>Mutlu bayramlar dileriz!</li>
                  <li>
                    Bu Ramazan Bayramı kalbinize sevgi, şans ve mutluluk
                    getirsin! Ramazan Bayramınız m&uuml;barek olsun.
                  </li>
                  <li>
                    Bu Ramazan Bayramı'nı t&uuml;m kardeşlerime, arkadaşlarıma
                    ve aileme, &ccedil;ok mutlu bir bayram diliyorum!
                  </li>
                  <li>
                    Ramazan Bayramı, &uuml;zerimizdeki t&uuml;m l&uuml;tfu
                    i&ccedil;in Allah'a ş&uuml;kretme g&uuml;n&uuml;d&uuml;r.
                    Size &ccedil;ok mutlu bir bayram diliyorum!
                  </li>
                  <li>
                    Bu Ramazan Bayramı'nda sevdiklerinizle birlikte nice
                    g&uuml;zel vakitler ge&ccedil;irmeniz dileğiyle. Bayramınız
                    M&uuml;barek olsun!
                  </li>
                  <li>
                    Size harika bir bayram g&uuml;n&uuml; diliyorum. Bayramınız
                    M&uuml;barek olsun!
                  </li>
                  <li>Bayramınızı en i&ccedil;ten dileklerimle kutlarım!</li>
                  <li>
                    Bu Ramazan Bayramı, Allah sizin ve ailenizin dualarını kabul
                    etsin. Bayramınız M&uuml;barek olsun!
                  </li>
                  <li>
                    Sizinle y&uuml;z y&uuml;ze g&ouml;r&uuml;şemeyebilirim ama
                    size ve ailenize bu Ramazan Bayramı'nda en i&ccedil;ten
                    dileklerimle g&ouml;nderiyorum. Bayramınız kutlu olsun!
                  </li>
                  <li>
                    Hayatınız huzur, g&uuml;venlik, sağlık, mutluluk ve refahla
                    dolsun. Bayramınız M&uuml;barek olsun!
                  </li>
                  <li>
                    İyi dileklerimi ve dualarımı yolunuza g&ouml;nderiyorum.
                    Size &ccedil;ok mutlu bir bayram diliyorum!
                  </li>
                  <li>
                    Bayram, mutlu olma ve Allah'ın bize bahşettiği her şey
                    i&ccedil;in ş&uuml;kretme g&uuml;n&uuml;d&uuml;r. Size
                    &ccedil;ok mutlu bir bayram diliyorum!
                  </li>
                  <li>
                    Bu m&uuml;barek g&uuml;nde, t&uuml;m sıkıntılarınız ortadan
                    kalksın. Bayramınız M&uuml;barek olsun.
                  </li>
                  <li>
                    Bu bayram, hayatınız mutlulukla, ruhunuz umutla, kalbiniz
                    sevgiyle, zihniniz hikmetle dolsun. Bayramınız M&uuml;barek
                    olsun!
                  </li>
                  <li>2023 Kurban Bayramınız Kutlu Olsun!</li>
                  <li>
                    <p>
                      Bu hayırlı g&uuml;n size neşe ve başarı getirsin. T&uuml;m
                      hayalleriniz ve dilekleriniz ger&ccedil;ekleşsin. Ramazan
                      Bayramınız M&uuml;barek olsun!
                    </p>
                  </li>
                </ul>
                <h2>
                  <strong>Kısa Bayram Mesajları</strong>
                </h2>
                <p>
                  Bayram mesajlarının uzun olmasına gerek yok. Kısa ve &ouml;z
                  bir şekilde de samimi dileklerde bulunabilirsiniz. İşte{' '}
                  <strong>kısa bayram mesajları</strong>:
                </p>
                <ul>
                  <li>
                    Bayramınız M&uuml;barek olsun! Sana t&uuml;m sevgilerimi ve
                    iyi dileklerimi g&ouml;nderiyorum.
                  </li>
                </ul>
                <ul>
                  <li>
                    Bu bayram huzur ve mutluluğun habercisi olsun. Bayramınız
                    kutlu olsun.
                  </li>
                </ul>
                <ul>
                  <li>
                    Bu Ramazan Bayramı size huzur, mutluluk ve refah diliyorum!
                  </li>
                </ul>
                <ul>
                  <li>
                    Bayramınız M&uuml;barek olsun! Allah t&uuml;m hayallerinizi
                    ve umutlarınızı ger&ccedil;ekleştirsin.
                  </li>
                </ul>
                <ul>
                  <li>
                    Bayramınız M&uuml;barek olsun! Bu bayram sana sevgilerimi ve
                    dualarımı g&ouml;nderiyorum.
                  </li>
                </ul>
                <ul>
                  <li>
                    Bu bayramın herkesin hayatına huzur, bereket ve mutluluk
                    getirmesini dilerim. Bayramınız M&uuml;barek olsun!
                  </li>
                </ul>
                <ul>
                  <li>
                    Size ve ailenize &ccedil;ok mutlu, m&uuml;reffeh ve huzur
                    dolu bir Ramazan Bayramı diliyoruz!
                  </li>
                </ul>
                <ul>
                  <li>
                    <p>
                      Size ve ailenize mutlu, m&uuml;reffeh ve sağlıklı bir
                      Kurban Bayramı diliyoruz!
                    </p>
                  </li>
                </ul>
                <h2>
                  <strong>Şirketler İ&ccedil;in Bayram Mesajları: </strong>
                </h2>
                <p>
                  &Ccedil;alışanlarınız ya da iş ortaklarınız i&ccedil;in
                  hazırladığımız bayram mesajlarını aşağıda inceleyebilirsiniz.
                  Aşağıda yer alan bayram mesajlarından dilediğinizi{' '}
                  <a
                    href="https://mesajussu.turkcell.com.tr/toplu-sms"
                    target="_blank"
                  >
                    <strong>
                      <u>toplu SMS</u>
                    </strong>
                  </a>
                  &nbsp;yoluyla g&ouml;nderebilirsiniz.
                </p>
                <ul>
                  <li>
                    Neşe, huzur, bereket, g&uuml;zellik, birlik ve beraberlik
                    dolu; mutlu bir Ramazan Bayramı diliyoruz. İyi Bayramlar.
                  </li>
                  <li>
                    Sevdiklerinizle beraber sağlıklı ve huzur i&ccedil;inde
                    mutlu bir bayram ge&ccedil;irmenizi dileriz.
                  </li>
                  <li>
                    Bu m&uuml;barek bayramın ulusumuza sağlık, huzur, mutluluk,
                    bolluk ve bereket getirmesini temenni ediyoruz. Hayırlı
                    bayramlar.
                  </li>
                  <li>
                    G&uuml;zellik, birlik ve beraberlik dolu bir bayram
                    diliyoruz.
                  </li>
                  <li>
                    Kurban Bayramı&rsquo;nın size ve sevdiklerinize mutluluk,
                    huzur ve refah getirmesi dileğiyle. Bayramınız m&uuml;barek
                    olsun.
                  </li>
                  <li>
                    Her g&uuml;n&uuml;n&uuml;z bayram tadında ge&ccedil;sin!
                    Sevdiklerinizle birlikte ge&ccedil;ireceğiniz g&uuml;zel bir
                    bayram dileriz.
                  </li>
                  <li>
                    Birlikte ge&ccedil;en mutlu g&uuml;nlere &ouml;zlem
                    duyduğumuz bu bayramı en g&uuml;zel şekilde
                    ge&ccedil;irmeniz dileğiyle. Mutlu bayramlar.
                  </li>
                  <li>
                    Ruhunuzu ve &ccedil;evrenizi tatlandıran, mutlu, umutlu,
                    bereketli bir bayram dileriz. &nbsp;
                  </li>
                  <li>
                    Şeker tadında bir Ramazan Bayramı ge&ccedil;irmenizi diler,
                    her şeyin g&ouml;nl&uuml;n&uuml;zce olmasını temenni ederiz.
                    İyi bayramlar.
                  </li>
                </ul>
                <p>
                  Mesaj &Uuml;ss&uuml;'ne &uuml;ye olarak, sizin i&ccedil;in
                  uygun olan{' '}
                  <a
                    href="https://mesajussu.turkcell.com.tr/paketler"
                    target="_blank"
                  >
                    <strong>
                      <u>toplu SMS paketlerini </u>
                    </strong>
                  </a>
                  keşfedebilirsiniz. M&uuml;şterilerinize mesaj ya da SMS
                  g&ouml;ndermeye hemen başlayabilirsiniz.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <FooterWithoutAuth />
    </Layout>
  );
};

export default BayramPage;
